enum WebhookEndpointStatus {
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  DELETED = "DELETED",
}

export default WebhookEndpointStatus;
